import { defineAction } from '~/prix'
import processAddressesAction from './geoProcessAddresses.action.json'
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const processAddressesDefinition = defineAction({
  ...processAddressesAction,
  input: z.object({
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      municipality: 'municipality',
    })
      .nullable()
      .default(null),
    ibgeCodes: z.string(),
  }),
  output: z.object({}),
})

export default processAddressesDefinition
